module.exports = new Promise(resolve => {
      const src = window.AppConfig.USER_MANAGEMENT_URL + "/remoteEntry.js"
      const script = document.createElement('script')
      script.src = src
       
       script.onload = () => {
        const proxy = {
          get: (request) => window.codat_user_management.get(request),
          init: (arg) => {
            try {
              return window.codat_user_management.init(arg)
            } catch(e) {
              console.error(e)
            }
          }
        }
        resolve(proxy)
      }
      script.onerror = () => {
        console.error("Failed to load " + src)
        resolve()
      }
      document.head.appendChild(script);
    });